// 表单工具方法库
import fecha from 'fecha'
fecha.masks = {
  default: 'YYYY-MM-DD HH:mm:ss',
  shortDatetime: 'YYYY-MM-DD HH:mm',
  date: 'YYYY-MM-DD',
  time: 'HH:mm:ss',
  month: 'YYYY-MM',
  hour: 'YYYY-MM-DD HH',
  hm: 'HH:mm'
}

const GenderOptions = [
    // { key: 'SECRET', value: '保密' },
    { key: 'MALE', value: '男' },
    { key: 'FEMALE', value: '女' }
  ]
  // 获取本周、本月、本年的时间段
function getMonday() {
  let date = new Date()
  let day = date.getDay()
  let deltaDay
  if (day === 0) {
    deltaDay = 6
  } else {
    deltaDay = day - 1
  }
  let monday = new Date(date.getTime() - deltaDay * 24 * 60 * 60 * 1000)
  return new Date(monday.getFullYear() + '-' + (monday.getMonth() + 1) + '-' + monday.getDate() + ' 00:00:00').getTime() // 返回本周的周一的0时0分0秒
}

function getMonthFirstDay() {
  let date = new Date()
  return new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-1' + ' ' + '00:00:00').getTime()
}

function getYearFirstDay() {
  let date = new Date()
  return new Date(date.getFullYear() + '-1-1 ' + '00:00:00').getTime()
}
export function getNowTimeParagraph(params = 'WEEK') {
  let value = ''
  let date = new Date()
  let nowTime = new Date(date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate() + ' ' + '23:59:59').getTime()
  if (params === 'WEEK') {
    // 获取本周一的零时零分零秒
    value = getMonday()
  } else if (params === 'MONTH') {
    // 获取本月1号的零时零分零秒
    value = getMonthFirstDay()
  } else if (params === 'YEAR') {
    // 获取本年一月一日的零时零分零秒
    value = getYearFirstDay()
  }
  return {
    nowTime: nowTime,
    value
  }
}
/**
 * 获取性别的选项
 */
export function getGenderOptions() {
  return GenderOptions
}

/**
 * 格式化性别
 * @param {*String or Nunber} code
 */
export function genderFormat(code) {
  switch (String(code)) {
    case '1':
      return '男'
    case '0':
      return '女'
  }
  for (let item of GenderOptions) {
    if (item.key === code) {
      return item.value
    }
  }
  return '保密'
}

/**
 * 将Date对象转换成unix timestamp
 */
export function dateToTimestamp(date) {
  return Math.round(date.getTime())
}
/**
 * 将unix timestamp转换成Date对象
 * @param {int} timestamp
 */
export function timestampToDate(timestamp) {
  return new Date(timestamp)
}
/**
 * 获取当前时间的unix timestamp
 */
export function getCurrentTimestamp() {
  return dateToTimestamp(new Date())
}
/**
 * Convert将指定的date值转换成date对象，可以接受timestamp、string或者date
 */

export function toDate(dateObject) {
  let date = null
  if (dateObject instanceof Date) {
    date = dateObject
  } else if (typeof dateObject === 'string') {
    date = new Date(dateObject)
  } else if (typeof dateObject === 'number') {
    if (dateObject === 0) {
      date = null
    } else {
      date = timestampToDate(dateObject)
    }
  }
  return date
}
/**
 * 将unix timestamp或者Date对象格式化成用于前端显示的字符串
 * 可选的格式:
 * 'default' - 'YYYY-MM-DD HH:mm:ss'
 * 'shortDatetime' - 'YYYY-MM-DD HH:mm'
 * 'date' - 'YYYY-MM-DD'
 * 'time' - 'HH:mm:ss'
 */
export function formatDateObject(dateObject, format = 'default') {
  if (!dateObject) {
    // console.warn('toData 方法必须接受一个有效且非空的参数')
    return ''
  }
  let date = toDate(dateObject)
  if (date == null) {
    return ''
  }
  return fecha.format(date, format)
}

/**
 * 格式化时间
 * @param {*Date} now
 */
export function formatDate(now, format = 'shortDatetime') {
  return formatDateObject(now, format)
}

/**
 * 对对象进行深度拷贝
 * @param {*} data
 */
export function deepClone(data) {
  return JSON.parse(JSON.stringify(data))
}

// 上传/获取的时候，钱数乘以/除以100,当get为true时，则为获取，除以100
export function cashCount(val, get, number) {
  number = number || 0
  val = typeof val === 'number' ? val : parseFloat(val)
  let value
  if (get) {
    value = number ? (val / 100).toFixed(number) : val / 100
  } else {
    value = val * 100
  }
  return value
}
// 导出数据处理回调函数
export function dataExport(data) {
  let blob = new Blob([data.data])
  if ('download' in document.createElement('a')) {
    // 非IE下载
    const elink = document.createElement('a')
    elink.download = data.fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, data.fileName)
  }
}
// 求数组中某个字段的最大值
export function maxValueMethod(arr, filed) {
  let maxValue = Math.max.apply(
    Math,
    arr.map(function(o) {
      return filed ? o[filed] : o
    })
  )
  return maxValue
}
// 求数组中某个字段的最小值
export function minValueMethod(arr, filed) {
  let minValue = Math.min.apply(
    Math,
    arr.map(function(o) {
      return filed ? o[filed] : o
    })
  )
  return minValue
}
// 判断空对象
export function isEmptyObject(obj) {
  for (var key in obj) {
    return false
  };
  return true
};
// 获取某时间戳所在日期的0点0分0秒
export function dateZero(date, type) {
  let data = date
  if (type === 'timestamp' || !type) {
    data = new Date(data)
  }
  data.setHours(0)
  data.setMinutes(0)
  data.setSeconds(0)
  data.setMilliseconds(0)
  if (type === 'timestamp' || !type) {
    data = data.getTime()
  }
  return data
}
/* 获取某一天及后几天0点0分0秒的时间戳
    date：为时间（某天，格式为时间戳）
    day：多少天之前或之后，number（之后为正数，之前为负数）
*/
export function dateZeroOfDay(date, day) {
  date.setHours(0)
  date.setMinutes(0)
  date.setSeconds(0)
  date.setMilliseconds(0)
  let dateTime = Date.parse(date)
  if (day) {
    dateTime = dateTime + day * 1000 * 60 * 60 * 24
  }
  return dateTime
}
/**
 * 根据生日计算年龄
 */
export function birthdayToAge(strBirthday) {
  strBirthday = formatDateObject(strBirthday, 'date')
  var returnAge
  var strBirthdayArr = strBirthday.split('-')
  var birthYear = Number(strBirthdayArr[0])
  var birthMonth = Number(strBirthdayArr[1])
  var birthDay = Number(strBirthdayArr[2])

  var d = new Date()
  var nowYear = d.getFullYear()
  var nowMonth = d.getMonth() + 1
  if (nowMonth < 10) {
    nowMonth = '0' + nowMonth
  }
  var nowDay = d.getDate()
  if (nowDay < 10) {
    nowDay = '0' + nowDay
  }
  if (nowYear === birthYear) {
    // 同年
    if (nowMonth === birthMonth) {
      return nowDay - birthDay + '天'
    } else {
      return nowMonth - birthMonth + '个月'
    }
  } else {
    var ageDiff = nowYear - birthYear // 年之差
    if (ageDiff > 0) {
      if (nowMonth === birthMonth) {
        var dayDiff = nowDay - birthDay // 日之差
        if (dayDiff < 0) {
          returnAge = ageDiff - 1 + '岁'
        } else {
          returnAge = ageDiff + '岁'
        }
      } else {
        var monthDiff = nowMonth - birthMonth // 月之差
        if (monthDiff < 0) {
          returnAge = ageDiff - 1 + '岁'
        } else {
          returnAge = ageDiff + '岁'
        }
      }
    } else {
      returnAge = -1 // 返回-1 表示出生日期输入错误 晚于今天
    }
  }
  return returnAge // 返回周岁年龄
}
/**
 * 根据生日计算年龄
 */
export function ToAge(age, ageType) {
  if (age && ageType) {
    const ageObj = {
      YEAR: '岁',
      MONTH: '个月',
      DAY: '天'
    }
    age = age + ageObj[ageType]
    return age
  } else {
    return ''
  }
}

// 获取签章名
export function getReportSignature(signature, name) {
  if (!signature) {
    return name
  }
  if (!name) {
    return signature
  }
  if (!name && !signature) {
    return ''
  }
  return signature + '(' + name + ')'
}
// 生成随机字符串(包含符号，字母和数字)

export function randomWord(randomFlag, min, max, data) {
  let str = ''
  let range = min
  let arr = data || ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l',
    'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
    'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
    '-', '.', '~', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '_', ':', '<', '>', '?'
  ]

  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min // 任意长度
  }
  for (let i = 0; i < range; i++) {
    let pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}
export function creatDownload(data, excelName = 'excel') {
  let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset = utf-8' }))
  console.log(url)
  var a = document.createElement('a')
  document.body.appendChild(a)
  a.href = url
  a.download = `${excelName}.xlsx`
  a.click()
  window.URL.revokeObjectURL(url)
}
// 根据某个属性的值进行排序，用法：arr.sort(sortByProperty('age'))
export function sortByProperty(property) {
  return function(a, b) {
    var value1 = a[property]
    var value2 = b[property]
    return value1 - value2
  }
}
// digit：位数
export function formatZero(number, digit) {
  return (Array(digit).join(0) + number).slice(-digit)
}
export function getHeader(index, config) {
  let innerHtml = ''
  switch (config.codeType) {
    case 'ALPHABET':
      innerHtml = letterHeader(index, config)
      break
    default:
      let zeroBefore = config.zeroBefore
        // 根据起始值与索引值（index）得到显示的列
      let value = (Number(config.codeStart)) + index
        // 补0
      let maxVal = Number(config.codeStart) + config.number - 1
      value = zeroBefore ? formatZero(value, String(maxVal).split('').length) : value // zeroBefore && value < 10 ? '0' : ''
      innerHtml = (config.prefix ? config.prefix : '') + value
  }
  return innerHtml
}
// 字母标题
function letterHeader(index, config) {
  // 根据起始值与索引值（index）得到显示的列
  let value = Number(config.codeStart.charCodeAt()) + index
  let header = (config.prefix ? config.prefix : '') + String.fromCharCode(value)
  return header
}
export function formatReaction(reactions) {
  let data = reactions.map((reaction, index) => {
    let { autoSlot } = reaction
    return {
      chipMaterialIds: reaction.chip.chipList.map(e => e.id),
      autoSlot,
      assignType: reaction.sortBy.toUpperCase(),
      referenceSamples: autoSlot ? null : getRefer(reaction.tableData, index + 1, reaction.chip.chipList[0].chipModel.attributes),
      assignArea: autoSlot ? null : getAssign(reaction.tableData, index + 1, reaction.chip.chipList[0].chipModel.attributes),
      reactionIndex: reactions.length === 1 ? null : index + 1,
      samplePlateId: reaction.platechip ? reaction.platechip.id : null,
      plateAssignType: reaction.plateAssignType ? reaction.plateAssignType.toUpperCase() : null
    }
  })
  let chipId = reactions.map((reaction, index) => {
    return reaction.chip.chipList.map(e => e.chipId)
  })
  let res = {
    data: data,
    chipId: chipId
  }
  return res
}

function getNumberIndex(config, key) {
  if (config.codeType === 'ALPHABET') {
    return key.substring(config.prefix ? config.prefix.length : 0).charCodeAt() - Number(config.codeStart.charCodeAt())
  }
  return Number(key.substring(config.prefix ? config.prefix.length : 0)) - Number(config.codeStart)
}

function getRefer(tableData, reactionIndex, chipConfig) {
  let res = []
    // 获取每行数据中选中的坐标
  function getSelectedKeys(row) {
    let selectedKeys = Object.keys(row).filter(e => row[e].selected === true && row[e].type !== 'smp' && row[e].reactionIndex === reactionIndex)
    let res = selectedKeys.map(key => {
      return {
        slot: {
          'row': getNumberIndex(chipConfig.rowModel, row.rowIndex), // row.rowIndex 行号 0开始
          'column': getNumberIndex(chipConfig.columnModel, key) // key 列号 0开始
        },
        sampleId: row[key].type === 'ntc' ? 'NTC' : `POS${row[key].index}`,
        labCode: row[key].type === 'ntc' ? 'NTC' : `POS${row[key].index}`
      }
    })
    return res
  }
  res = tableData.map(e => {
    return getSelectedKeys(e)
  }).reduce(function(a, b) { return a.concat(b) })
  return res
}

function getAssign(tableData, reactionIndex, chipConfig) {
  let res = []
    // 获取每行数据中选中的坐标
  function getSelectedKeys(row) {
    let selectedKeys = Object.keys(row).filter(e => row[e].selected === true && row[e].type === 'smp' && row[e].reactionIndex === reactionIndex)
    let res = selectedKeys.map(key => {
      return {
        slot: {
          'row': getNumberIndex(chipConfig.rowModel, row.rowIndex), // row.rowIndex 行号 0开始
          'column': getNumberIndex(chipConfig.columnModel, key) // key 列号 0开始
        }
      }
    })
    return res
  }
  res = tableData.map(e => {
    return getSelectedKeys(e)
  }).reduce(function(a, b) { return a.concat(b) })
  return res
}
//用于补充位数（如果传入的数据位数小于m位，前面用0补齐）
/*n为需要处理的数据*/
/*m为最少需要保留的位数*/
export function prefixZero(n,m){
  let length=_.isString(n)?n.length:String(n).length
  console.log('length',length)
  if(length>=m) return n
	var _a = (Array(m).join(0) + n).slice(-m);
	return _a;
}